import { EXPENSE_CATEGORY_EMPTY_OPTION } from 'src/components/ExpenseCategoryDropdown/ExpenseCategoryDropdown'
import { AppliedExpenseDetailRequest } from 'src/requests/appliedExpenseCategory.request'

export interface PatchTransactionExpenseDataRequest {
  expenseDetails: AppliedExpenseDetailRequest[]
}

export interface PatchBulkTransactionExpenseDataRequest {
  transactionIds?: string[]
  expenseDetails: AppliedExpenseDetailRequest[]
}

// Map txn exp details dropdown options to null to allow for setting values to empty
export const mapExpDetailsToNulls = (
  expenseDetails: Record<string, string>,
): Omit<PatchBulkTransactionExpenseDataRequest, 'transactionIds'> => {
  return {
    expenseDetails:
      expenseDetails !== undefined
        ? Object.entries(expenseDetails).map(
            ([catId, labelId]) =>
              ({
                categoryId: catId,
                labelId:
                  labelId === EXPENSE_CATEGORY_EMPTY_OPTION ? null : labelId,
              }) as AppliedExpenseDetailRequest,
          )
        : [],
  }
}
